<div class="alerts container">
    <div class="alerts__container" :class="{'alerts__container-mobile': userStore.mobile}">
        <transition v-for="alert in messages" :key="alert.id" name="slide-fade">
            <div class="alerts__alert" :class="`alerts__alert-${alert.class}`">
                <div class="d-flex" @click="goFavorite(alert.content?.advert)">
                    <div class="avatar" v-if="typeof alert.content === 'object'"><span :style="{ 'background-image': `url(${getAvatar(alert.content.avatar)})`}"></span></div>
                    <div v-else class="icon"></div>
                    <div class="content">
                        <p>{{ typeof alert.content === 'object' ? alert.content.message : alert.content }}</p>
                    </div>
                </div>
                <div class="close" @click="removeMessage(alert.id)"></div>
            </div>
        </transition>
    </div>
</div>
